import { render, staticRenderFns } from "./Actions.vue?vue&type=template&id=30123186&scoped=true&"
import script from "./Actions.vue?vue&type=script&lang=ts&"
export * from "./Actions.vue?vue&type=script&lang=ts&"
import style0 from "./Actions.vue?vue&type=style&index=0&id=30123186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30123186",
  null
  
)

export default component.exports